/* eslint-disable no-console */
import * as ActionTypes from './ActionTypes'
import { Map } from 'immutable'

const getInitialState = () => {
  return Map({
    currentOrderUuid: null, // current, active order
    orderAction: Map({}),
  })
}

const reducer = (state = getInitialState(), action) => {
  switch (action.type) {
    case ActionTypes.VNORDERS_SET_CURRENT_ORDER_UUID:
      return state.set('currentOrderUuid', action.orderUuid)
    case ActionTypes.VNORDERS_SET_ORDER_ACTION:
      console.log('VNORDERS_SET_ORDER_ACTION - reducer', action)
      return state.set('orderAction', Map(action.orderAction))
    default:
      return state
  }
}

export default reducer
